export class Platform {
  public static readonly ANDROID: string = "Android";
  public static readonly IPHONE: string = "iPhone";
  public static readonly IPAD: string = "iPad";
  public static readonly HARMONY_OS: string = "HarmonyOS";

  readonly title: string;
}
